import * as tslib_1 from "tslib";
import FocusedInboxPivot from './FocusedInboxPivot';
import { observer } from 'mobx-react';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import Droppable from 'owa-dnd/lib/components/Droppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { resetFocus } from 'owa-mail-focus-manager';
import { isAllDefaultForFocusedInbox, isFocusedInboxPivotExperimentOn, } from 'owa-mail-list-actions';
import selectFocusedViewFilter from 'owa-mail-list-actions/lib/actions/selectFocusedViewFilter';
import { mailStore } from 'owa-mail-store';
import * as lazyTriageActions from 'owa-mail-triage-action';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { getFocusedOtherDropViewState, getFocusedFilterForTable, listViewStore, } from 'owa-mail-list-store';
var styles = require('./MailListHeaderSecondRow.scss');
var classNames = require('classnames/bind').bind(styles);
var FocusedInboxHeader = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedInboxHeader, _super);
    function FocusedInboxHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderFocusedOtherPivot = function () {
            return (React.createElement(FocusedInboxPivot, { tableViewId: _this.props.tableViewId, unseenCountToDisplay: _this.props.unseenCountToDisplay, canDrop: _this.canDropOnFocusOtherPill, onDrop: _this.onDropFocusOtherPill, onKeyDown: _this.onKeyDownOnFocusedOther, isSupportedItemTypeForDragDrop: _this.isSupportedItemTypeForDragDrop(mailStore.typeOfItemBeingDragged), shouldShowOnDropHoverTreatment: getFocusedOtherDropViewState().isDragOver }));
        };
        _this.renderFocusedOtherPill = function () {
            var tableView = listViewStore.tableViews.get(_this.props.tableViewId);
            var ariaProps = {
                role: AriaRoles.button,
            };
            var isFocusedCurrentlySelected = getFocusedFilterForTable(tableView) == 0 /* Focused */;
            return (React.createElement("div", { className: styles.focusedOtherContainer },
                React.createElement("span", { className: "screenReaderOnly", role: "heading", "aria-level": 2 }, isFocusedCurrentlySelected
                    ? strings.focusedViewFilterText
                    : strings.otherViewFilterText),
                React.createElement("div", tslib_1.__assign({ className: styles.pillContainer, tabIndex: 0 }, generateDomPropertiesForAria(ariaProps), { onKeyDown: _this.onKeyDownOnFocusedOther, onClick: function () {
                        return _this.onFocusedOtherClicked(!isFocusedCurrentlySelected /* shouldSelectFocusPivot */);
                    } }),
                    _this.renderPill(true /*isFocusedPill*/, isFocusedCurrentlySelected),
                    _this.renderPill(false /*isFocusedPill*/, !isFocusedCurrentlySelected))));
        };
        _this.onFocusedOtherClicked = function (shouldSelectFocusPivot) {
            selectFocusedViewFilter(shouldSelectFocusPivot ? 0 /* Focused */ : 1 /* Other */, 'FocusedOtherPivot');
        };
        _this.onDropFocusOtherPill = function (dragInfo) {
            if (_this.isSupportedItemTypeForDragDrop(dragInfo.itemType)) {
                var mailListRowDragData = dragInfo;
                lazyTriageActions.lazyMoveMailListRowsToFocusedOrOther.importAndExecute(mailListRowDragData.rowKeys, mailListRowDragData.tableViewId, 'Drag');
            }
        };
        _this.canDropOnFocusOtherPill = function (dragInfo) {
            return _this.isSupportedItemTypeForDragDrop(dragInfo.itemType);
        };
        /**
         * Called when user presses keyboard on the focused other button in listview
         */
        _this.onKeyDownOnFocusedOther = function (ev) {
            var tableView = listViewStore.tableViews.get(_this.props.tableViewId);
            var isFocusedSelected = getFocusedFilterForTable(tableView) == 0 /* Focused */;
            switch (ev.keyCode) {
                case 13 /* Enter */:
                case 32 /* Space */:
                    ev.stopPropagation();
                    ev.preventDefault();
                    selectFocusedViewFilter(isFocusedSelected ? 1 /* Other */ : 0 /* Focused */, 'Keyboard');
                    // Reset focus when filter context menu is dismissed
                    resetFocus();
                    break;
            }
        };
        return _this;
    }
    FocusedInboxHeader.prototype.render = function () {
        var allDefaultForFocusedInbox = isAllDefaultForFocusedInbox();
        var isUserOnFocusedInboxExperimentFlight = isFocusedInboxPivotExperimentOn();
        // Show F/O header as pivots if
        // - user is on any of the experiment client flights
        // - or if server flight AllDefaultForFocusedInbox is ON, which means session data returns All inbox data, we cannot
        //   use the pill because pill only has two states - Focused and Other. This could happen when the server
        //   flight is enabled before the client experiment flight.
        var shouldShowFocusedPivots = allDefaultForFocusedInbox || isUserOnFocusedInboxExperimentFlight;
        return shouldShowFocusedPivots
            ? this.renderFocusedOtherPivot()
            : this.renderFocusedOtherPill();
    };
    FocusedInboxHeader.prototype.renderPill = function (isFocusedPill, isSelected) {
        var pillName = isFocusedPill
            ? strings.focusedViewFilterText
            : strings.otherViewFilterText;
        var shouldShowDropHint = this.isSupportedItemTypeForDragDrop(mailStore.typeOfItemBeingDragged);
        var selectedPillClassName = classNames(styles.pill, isSelected && styles.selectedPill);
        var dropViewState = getFocusedOtherDropViewState();
        var nonSelectedPillClassName = classNames(styles.pill, { pillDropHint: shouldShowDropHint }, { shouldShowHoverTreatment: dropViewState.isDragOver });
        return isSelected ? (React.createElement("div", { className: selectedPillClassName }, pillName)) : (React.createElement(Droppable, { classNames: nonSelectedPillClassName, dropViewState: dropViewState, onDrop: this.onDropFocusOtherPill, canDrop: this.canDropOnFocusOtherPill }, pillName));
    };
    FocusedInboxHeader.prototype.isSupportedItemTypeForDragDrop = function (itemType) {
        return (itemType == DraggableItemTypes.MailListRow ||
            itemType == DraggableItemTypes.MultiMailListConversationRows ||
            itemType == DraggableItemTypes.MultiMailListMessageRows);
    };
    FocusedInboxHeader = tslib_1.__decorate([
        observer
    ], FocusedInboxHeader);
    return FocusedInboxHeader;
}(React.Component));
export default FocusedInboxHeader;
//# sourceMappingURL=FocusedInboxHeader.js.map